import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useRoute } from "@/routes/getRoute";
import { UserDisplayWrapperProps } from "@zeemee/react-web-chat";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export const UserDisplayWrapper: FC<UserDisplayWrapperProps> = ({
  user,
  children,
  ...props
}) => {
  const getRoute = useRoute();
  const { t } = useTranslation();

  if (user.__typename !== "Student") {
    return (
      <button
        {...props}
        onClick={(e) => {
          props.onClick?.(e);
          toast.error(t("chat.chatUserDisplayWrapper.notStudentTitle"), {
            description: t("chat.chatUserDisplayWrapper.notStudentText"),
            action: {
              label: t("global.close"),
              onClick: () => {
                // Close action - no additional logic needed
              },
            },
          });
        }}
      >
        {children}
      </button>
    );
  }

  return (
    <Link {...props} to={getRoute("student", { studentId: user.id })}>
      {children}
    </Link>
  );
};
